import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTriangleExclamation } from "@fortawesome/free-solid-svg-icons";
import ChecklistCard from "./ChecklistCard";

export default function ABMustRefer({ IsMLS }) {
  const [ReferralDocs, setReferralDocs] = useState([
    "eXp Referral Document",
    "MLS Sheet (Full Agent Detail View)",
  ]);

  useEffect(() => {
    if (IsMLS === "Exclusive") {
      setReferralDocs(["Referral Document"]);
    } else {
      setReferralDocs([
        "Referral Document",
        "MLS Sheet (Full Agent Detail View)",
      ]);
    }
  }, [IsMLS]);

  return (
    <>
      <div className="clause-card-content ab-must-refer-warning-wrap">
        <div className="clause-warning">
          <div className="clause-warning-icon">
            <FontAwesomeIcon icon={faTriangleExclamation} size="lg" />
          </div>
          <div>
            You cannot represent both clients, or treat one as a customer, in a
            trade when you have direct interest in the listed property. As a
            result, you must release or refer one of the client(s) to another
            agent. However, you can collect a referral fee on the client
            referral.
          </div>
        </div>
      </div>

      <ChecklistCard
        CheckListData2={ReferralDocs}
        CheckListData={["Added to Deal Sheet"]}
        Header={"Referral"}
        Title2="Referral Documents (Outside Brokerage Listing)"
        Title1="Referral Documents (eXp Listing)"
        province="AB"
      />
    </>
  );
}
